export default __webpack_public_path__ + "static/media/relative-humidity.49de9d1d.png";